import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventService } from '@shared/service/event.service';
import { ToasterEventModel } from './models';
import { SystemService } from '../../service/system/system.service'

import {
  ToastHeaderComponent,
  ToastBodyComponent,
  ToastComponent,
  ToasterComponent,
  ProgressComponent,
} from '@coreui/angular-pro';

@Component({
  selector: 'toaster-popup',
  imports: [
    CommonModule,
    ToastHeaderComponent,
    ToastBodyComponent,
    ToastComponent,
    ToasterComponent,
    ProgressComponent,
  ],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss'
})
export class CsToasterComponent implements OnInit {
  private event = inject(EventService);
  private systemService = inject(SystemService);
  private nextId = 0;

  position = 'top-end';
  toasts = signal<ToastItem[]>([]);


  ngOnInit(): void {
    this.event.listen('toast-error', (data: ToasterEventModel) => {
      this.addToast(data, 'toast-error');
    });

    this.event.listen('toast', (data: ToasterEventModel) => {
      this.addToast(data, 'toast-default');
    });
  }

  onVisibleChange(visible: boolean, id: number) {
    if (!visible) {
      this.toasts.update((items) => items.filter((item) => item.id !== id));
      return;
    }
    this.toasts.update((items) =>
      items.map((item) => (item.id === id ? { ...item, visible } : item))
    );
  }

  onTimerChange($event: number, id: number) {
    this.toasts.update((items) =>
      items.map((item) =>
        item.id === id ? { ...item, percentage: $event * 25 } : item
      )
    );
  }

  trackByToastId(_index: number, toast: ToastItem) {
    return toast.id;
  }

  private addToast(data: ToasterEventModel, className: string) {
    const toast: ToastItem = {
      id: ++this.nextId,
      header: data.header,
      body: data.payload,
      className,
      percentage: 0,
      visible: true,
    };
    this.toasts.update((items) => [...items, toast]);
  }
  
  get direction() {
    return this.systemService.direction();
  }

}

interface ToastItem {
  id: number;
  header: string;
  body: string;
  className: string;
  percentage: number;
  visible: boolean;
}
